import { faBrainCircuit, faMemoPad, faMessagesQuestion, faThumbsUp } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QuickCopyButton from '../common/QuickCopyButton';
import FavoriteButtonContainer from '@/components/favorites/FavoriteButtonContainer';
import React from 'react';
import VoteButtons from './vote/VoteButtons';
import { TenderVote } from '@/actions/dtos/tender/vote';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';
import { useTranslations } from 'next-intl';

interface TenderNavbarProps {
  tenderId: string;
  isActive: boolean;
  hasDocuments: boolean;
  quickCopyText: string;
  isAuthenticated: boolean;
  shortlistId: string | null;
  shortlistEntryId: string | null;
  setIsSidebarOpenedOnMobile: (arg0: boolean) => void;
  onSectionClick?: (section: string) => void;
  searchExecutionId?: string;
  votes?: TenderVote[];
  onVoteChange?: () => void;
}

const TenderNavbar: React.FC<TenderNavbarProps> = ({
  tenderId,
  isActive,
  hasDocuments,
  quickCopyText,
  isAuthenticated,
  setIsSidebarOpenedOnMobile,
  shortlistId,
  shortlistEntryId,
  onSectionClick,
  searchExecutionId,
  votes,
  onVoteChange,
}) => {
  const handleSectionClick = (section: string) => {
    setIsSidebarOpenedOnMobile(true);
    if (onSectionClick) {
      onSectionClick(section);
    }
  };

  const t = useTranslations();

  return (
    <div className="card mb-4 w-full rounded-lg bg-base-200 px-2">
      <div className={`flex w-full items-center justify-between gap-1`}>
        <div className="flex items-center gap-2">
          <QuickCopyButton text={quickCopyText} />

          {isAuthenticated && (
            <FavoriteButtonContainer tenderId={tenderId} shortlistId={shortlistId} initEntryId={shortlistEntryId} />
          )}

          <VoteButtons
            searchExecutionId={searchExecutionId}
            tenderId={tenderId}
            onVoteChange={onVoteChange}
            votes={votes}
            dropdownPosition="right"
          />
        </div>

        <div className="dropdown dropdown-end">
          <div tabIndex={0} role="button" className="btn btn-square btn-ghost" aria-label="More Options">
            <FontAwesomeIcon className="h-5 w-5" icon={faEllipsisVertical} />
          </div>
          <ul tabIndex={0} className="menu dropdown-content z-[1] w-3xs rounded-box bg-base-100 p-2 shadow">
            <li>
              <button className="flex items-center gap-3" onClick={() => handleSectionClick('kiScore')}>
                <FontAwesomeIcon className="h-5 w-5" icon={faBrainCircuit} />
                <span>{t('TenderSidebar_ScoreSection_Title')}</span>
              </button>
            </li>
            <li>
              <button className="flex items-center gap-3" onClick={() => handleSectionClick('teamVotes')}>
                <FontAwesomeIcon className="h-5 w-5" icon={faThumbsUp} />
                <span>{t('TenderSidebar_VoteSection_Title')}</span>
              </button>
            </li>
            {isActive && hasDocuments && (
              <li>
                <button className="flex items-center gap-3" onClick={() => handleSectionClick('kiChats')}>
                  <FontAwesomeIcon className="h-5 w-5" icon={faMessagesQuestion} />
                  <span>{t('TenderSidebar_ChatSection_Title')}</span>
                </button>
              </li>
            )}
            <li>
              <button className="flex items-center gap-3" onClick={() => handleSectionClick('notesAndComments')}>
                <FontAwesomeIcon className="h-5 w-5" icon={faMemoPad} />
                <span>{t('TenderSidebar_NoteSection_Title')}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TenderNavbar;
